module.exports = __webpack_public_path__ + "static/img/logo_4.9b998bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_4.png
// module id = ed4S
// module chunks = 1